/* ASJ CUSTOM: progressive enhancement for the header dropdowns.
   Adds desktop hover/focus open (incl. the nested "Buy" submenu) on top of
   Dawn's native click-to-open <details> menu. Mobile is untouched (the inline
   menu is hidden on mobile; the drawer handles tap toggles). Safe to delete. */
(function () {
  if (!window.matchMedia) return;
  var desktop = window.matchMedia('(min-width: 990px)');

  function init() {
    var menu = document.querySelector('.header__inline-menu');
    if (!menu) return;
    var timers = new WeakMap();

    function open(d) { if (!d.hasAttribute('open')) d.setAttribute('open', ''); }
    function close(d) { if (d.hasAttribute('open')) d.removeAttribute('open'); }

    menu.querySelectorAll('details').forEach(function (d) {
      d.addEventListener('mouseenter', function () {
        if (!desktop.matches) return;
        clearTimeout(timers.get(d));
        open(d);
      });
      d.addEventListener('mouseleave', function () {
        if (!desktop.matches) return;
        // grace period so moving into the submenu keeps it open
        timers.set(d, setTimeout(function () { close(d); }, 180));
      });
      d.addEventListener('focusin', function () {
        if (desktop.matches) open(d);
      });
      d.addEventListener('focusout', function (e) {
        if (desktop.matches && !d.contains(e.relatedTarget)) close(d);
      });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init, { once: true });
})();
